import React from "react";
import PageTitle from "../../layout/PageTitle";

const ProviderFunctionalities = () => {
  return (
    <div className="container">
      <PageTitle title='Functionalitati Nutritionist'/>

      <ul>
        <li>Dashboard</li>
        <li>
          Mesele zilei
        </li>
        <li>Ingrediente - ??? Lista comuna de ingrediente pe toata platforma sau per nutritionist ???
          <ul>
            <li><u>Vizualizare ingrediente default</u></li>
            <li><u>Import ingrediente default</u></li>
            <li><u>Ingrediente alternative - ??? in functie de meniu, sau global ??? </u></li>
          </ul>
        </li>
        <li>Retete
          <ul>
            <li>
              <strong>Definire reteta/masa</strong> - poza, denumire, descriere
            </li>
            <li>
              <strong>Definire lista de ingrediente</strong> - ingredient, cantitate, unitate de masura, cantitate
              aproximativa
            </li>
          </ul>
        </li>
        <li>
          Meniuri
          <ul>
            <li><strong>Definire meniu</strong> - poza, denumire, descriere</li>
            <li><strong>Definire lista retete</strong> - Reteta, Ziua de meniu, perioada zilei</li>
            <li><strong><u>Meniuri alternative</u></strong>
              <u>
                <ul>
                  <li>Ajutor automat pentru meniu personalizat <br/>(bazat pe lista de ingrediente pe care clientul nu
                    le poate manca)
                  </li>
                </ul>
              </u>
            </li>
          </ul>
        </li>
        <li>
          Clienti
          <ul>
            <li><strong>Adaugare client</strong> - Nutritionistul poate invita mai multi clienti in platforma</li>
            <li><strong>Vizualizare client</strong>
              - Detalii cont client, statusul invitatiei
              <ul>
                <li>Detalii cont client</li>
                <li>Lista meniuri client</li>
                <li>Lista comentarii</li>
                <li>Lista ratinguri</li>
                <li>Lista afectiuni</li>
                <li>Lista medicamente</li>
                <li>Lista alergii</li>
                <li>Lista alimente pe care clientul nu le poate manca</li>
              </ul>
            </li>
            <li><strong>Adaugare/Share Meniuri</strong> - Odata adaugat un meniu, aplicatia face o copie a intregului
              meniului selectat doar pentru acest client.<br/>
              Astfel:
              <ul>
                <li>O modificare a meniului initial nu afecteaza meinurile deja trimise clientilor</li>
                <li>O modificare a meniului asignat unui client nu se implica modificare meiului initial sau al altor
                  clienti cu acelasi meniu initial, permitand o usoara <strong>personalizare a meniului</strong> per
                  client
                </li>
                <li>Meniul are un status astfel ca nutritionistul poate asigna un meniu cu statusul inactiv, poate
                  personaliza acest meniu pentru client si apoi poate activa meniul.<br/>
                  Clientul vede doar meniurile active.
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>Editare profil</li>
        <li>Notificari
          <ul>
            <li><strong>Setari</strong></li>
            <li>
              <strong>Notificari legate de clienti</strong>
              <ul>
                <li>adaugare / editare / stergere masuratori</li>
                <li>actiuni asupra meselor din meniu</li>
                <li>adaugare rating</li>
                <li>adaugare comentariu</li>
              </ul>
            </li>
            <li><u>
              <strong>Notificari legate de chat</strong>
              <ul>
                <li>Adaugare mesaj</li>
              </ul>
            </u>
            </li>
            <li>
              <strong>Notificari legate retete</strong>
              <ul>
                <li>comentarii</li>
                <li>rating</li>
              </ul>
            </li>
          </ul>
        </li>
        <li><u>Chat cu clientii</u>
          <ul>
            <li><u>Chat per clientul</u></li>
            <li><u>Chat per meniu</u></li>
          </ul>
        </li>
        <li><u>Rapoarte</u></li>

        <li>...</li>
      </ul>

      Mancare = Reteta = Masa
      <br/>
      <strong><u>Ce este subliniat nu este implementat</u></strong>
    </div>
  )
};

export default ProviderFunctionalities;